import React from 'react';
import block from 'propmods';
import { Loading } from '../Loading/Loading';

import './SuggestLoading.scss';

const b = block('Suggest');

export const SuggestLoading: React.FC = () => (
    <div {...b('loading')}>
        <Loading size="xs" />
    </div>
);
